import _regeneratorRuntime from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageTitle from '~/components/PageTitle';
export default {
  components: {
    PageTitle: PageTitle
  },
  props: ['isShow'],
  data: function data() {
    return {
      items: [{
        name: "项目",
        name_en: 'Project',
        child: [{ name: "所有项目", name_en: 'All Project', url: "/project/" }]
      }, {
        name: "关于我们", name_en: 'About us',
        child: [{ name: "公司简介", name_en: 'Commpany profile', url: "/us" }, { name: "团队介绍", name_en: 'Team Presentation', url: "/us/team" }, { name: "联系我们", name_en: 'Contact us', url: "/us/contact" }, { name: "加入我们", name_en: 'Join us', url: "/us/join" }]
      }, {
        name: "企业文化", name_en: 'Corporate culture',
        child: []
      }, {
        name: "工程工艺", name_en: 'Engineering',
        child: []
      }, {
        name: "养护工艺", name_en: 'Curing',
        child: []
      }, { name: "园林基地", name_en: 'Gardens' }, { name: "新闻", name_en: 'News' }],
      detailExpanding: false
    };
  },

  methods: {
    show: function show(e) {

      document.querySelectorAll('.list-name').forEach(function (val, key) {
        val.style.display = 'none';
      });
      if (e.target.getAttribute('data-show') === 'close') {
        e.target.setAttribute('data-show', 'show');
        var Node = e.target.parentNode.parentNode;
        Node.querySelectorAll('.list-name').forEach(function (val, key) {
          val.style.display = 'block';
        });
      } else {
        e.target.setAttribute('data-show', 'close');
        var _Node = e.target.parentNode.parentNode;
        _Node.querySelectorAll('.list-name').forEach(function (val, key) {
          val.style.display = 'none';
        });
      }
    },
    select: function select(index) {
      if (index === 5) {
        this.$router.push({ path: '/garden', query: { lang: this.lang } });
      } else if (index === 2) {
        this.$router.push({ path: '/culture', query: { lang: this.lang } });
      } else if (index === 6) {
        this.$router.push({ path: '/news', query: { lang: this.lang } });
      }
    },
    toggleLang: function toggleLang(param) {
      this.$store.state.lang = param;
      this.expanding = false;
      this.detailExpanding = false;
      this.idx = null;
      if (this.$route.query.index) {
        this.$router.push({ path: this.$route.path, query: { index: this.$route.query.index, lang: param } });
      } else {
        this.$router.push(this.$route.path + '?lang=' + param);
      }
    },
    backTop: function backTop() {

      $('.main-component').animate({ scrollTop: 0 }, 'slow');
      $('body').animate({ scrollTop: 0 }, 'slow');
      $('.project-details').animate({ scrollTop: 0 }, 'slow');
    },
    getList: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var results, result, resulte;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch("getPageIndex", { lang: this.lang });

              case 2:
                results = _context.sent;
                _context.next = 5;
                return this.$store.dispatch("getPageData", { id: "8", lang: this.lang });

              case 5:
                result = _context.sent;
                _context.next = 8;
                return this.$store.dispatch("getPageData", { id: "7", lang: this.lang });

              case 8:
                resulte = _context.sent;

                results.reverse().forEach(function (val, index) {
                  _this.items[0].child.splice(index + 1, flag, { name: val.title, name_en: val.title, url: '/project/' + val.id });
                });
                result.reverse().forEach(function (val, index) {
                  _this.items[4].child.splice(index, flag, { name: val.title, name_en: val.title, url: '/curing?index=' + index });
                });
                resulte.reverse().forEach(function (val, index) {
                  _this.items[3].child.splice(index, flag, { name: val.title, name_en: val.title, url: '/engin?index=' + index });
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getList() {
        return _ref.apply(this, arguments);
      }

      return getList;
    }()
  },
  computed: {
    winHeight: function winHeight() {
      return this.$store.state.winHeight;
    },
    lang: function lang() {
      return this.$store.state.lang;
    }
  },
  watch: {
    lang: function lang(newValue) {
      if (newValue) {
        this.getList(1);
      }
    }
  },
  created: function created() {
    this.getList();
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonFooter.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonFooter.vue
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14